import ParmGroupOrigin, {ParmGroupProps} from './components/ParmGroup';
export const ParmGroup = ParmGroupOrigin as unknown as React.FC<ParmGroupProps>;

export { type dictionary } from './types/Houdini';
export { hou } from './types/Houdini';

import './houdini.css';